<template>
  <div class="PCProduct" v-if="getRelationListResult.ProductDetail">
    <div class="product_top flex_row">
      <div class="left">
        <el-carousel  width="100%" arrow="always" @change="changeCarousel" ref="carousel">
          <el-carousel-item v-for="(item, index) in ProductDetail.ListUploadFile" :key="index">
            <div class="big_Img flex_row">
              <img :src="item.FullURL" alt="" style="width: 100%">
            </div>
          </el-carousel-item>
          <div class="left_search flex_row" @click="searchClick">
            <img src="@/assets/img/search.png">
          </div>
        </el-carousel>
        <div class="small_Img flex_row" @click="setActiveItem">
          <div class="img_border flex_row" v-for="(item, index) in ProductDetail.ListUploadFile" :key="index">
            <img :src="item.FullURL" alt="" :data-index="index" :class="carouselIndex==index?'pattern': ''">
          </div>
        </div>
      </div>
      <div class="right">
        <div class="product_name">
          <div class="title">{{Brand.BrandName}}</div>
          <p class="info">{{Product.ProductName}}</p>
        </div>
        <div class="product_name">
          <div class="info">官方指导价：（￥{{ Product.ProductOfficalPrice }}）</div>
        </div>
        <div class="product_price flex_row" v-show="SPPrice !== ''">
          <div class="price_tag">价格</div>
          <div class="price">￥{{SPPrice}}</div>
        </div>
        <div class="product_num flex_row" :style="{'visibility':CHPChooseId?'visible': 'hidden'}">
          <div class="num_tag">数量</div>
          <div class="num">{{ProductNum}}</div>
          <div class="num_mode">
            <div class="num_add" @click="addClick">&#9650</div>
            <div class="num_sub" @click="subClick">&#9660</div>
          </div>
        </div>
        <div class="product_buy flex_row_start">
          <button class="buy" style="display: none">立即购买</button>
          <button class="shop" @click="addCart" :style="{'display':CHPChooseId?'block': 'none'}"><img src="@/assets/img/shop.png">加入购物车</button>
        </div>
      </div>
    </div>
    <div class="product_details">
      <div class="details_top">商品详情</div>
      <div class="details_body">
        <div class="details_item flex_row">
          <div class="tag">品牌：</div>
          <div class="details">{{Brand.BrandName}}</div>
        </div>
        <div class="details_item flex_row">
          <div class="tag">名称：</div>
          <div class="details">{{Product.ProductName}}</div>
        </div>
        <div class="details_item flex_row">
          <div class="tag">单位：</div>
          <div class="details">{{AllProduct.ProductUnit}}</div>
        </div>
        <div class="details_item flex_row">
          <div class="tag">规格：</div>
          <div class="details">{{AllProduct.ProductFormat}}</div>
        </div>
        <div class="details_item flex_row">
          <div class="tag">规格数：</div>
          <div class="details">{{AllProduct.ProductFormatQuantity}}</div>
        </div>
        <div class="details_item flex_row">
          <div class="tag">描述：</div>
          <div class="details">{{Product.ProductDes}}</div>
        </div>
        <div class="details_items flex_row">
          <div class="flex_row details_item" v-for="(item, index) in ProductDetail.ListProperty" :key="index" :class="index % 2 == 0 ? '': 'details_item1'">
            <div class="tag">{{item.PropertyGroup.PropertyGroupName}}：</div>
            <div class="details">{{item.PropertyValue}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="details_intro">
      <div class="intro_border flex_row" v-for="(item, index) in ProductDetail.ListUploadFileDetail" :key="index">
        <img :src="item.FullURL" alt="" :data-index="index">
      </div>
    </div>
    <el-dialog class="dialog" :visible.sync="dialogTableVisible" style="width: 100vw">
      <img :src="imgSrc.FullURL" alt="" style="width: 100%">
    </el-dialog>
  </div>
</template>

<script>
import {Loading, MessageBox} from "element-ui";
import axios from "@/axios/axios";
import store from "@/store";
export default {
  name: 'PCProduct',
  components: {
  },
  data() {
    return {
      carouselIndex: 0,
      getRelationListResult: {},
      ProductDetail: {},
      Brand: {},
      Product: {},
      AllProduct: {},
      ProductNum: 1,
      CHPChooseId: '',
      CHPProductId: '',
      dialogTableVisible: false,
      imgSrc: '',
      ShopId: '',
      SPPrice: ''
    }
  },
  created() {
    this.CHPChooseId = this.$route.query.CHPChooseId;
    this.CHPProductId = this.$route.query.CHPProductId;
    this.ShopId = this.$route.query.ShopId;
    if (this.$store.state.bases.urlArr.length > 0) {
      let arr = this.$store.state.bases.urlArr
      let item = new Map()
      for (let i = 0; i < arr.length; i++) {
        item.set(arr[i].IAKey, arr[i].IAValue)
      }
      this.$store.commit('bases/UpUrlMap', item);
      this.priceSortList();
    }else {
      this.GetInterfaceAddress();
    }
  },
  methods: {
    GetInterfaceAddress() {
      let loadingInstance = Loading.service({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      });
      let val = '0510D02D-3A1F-4796-B303-DAAE36394606'
      axios.post('https://wsbusiness.visumall.com/BusinessConfig.ashx?cmd=GetInterfaceAddress', {
        "token": {
          "sToken": "8BED23DE028E0E9966B8CE9E8F77DB89",
          "TimeSpan": "1535942069232"
        },
        "SearchCondition":{
          "BCTypeId": val
        }
      })
          .then(res => {
            if (res.InterfaceAddress) {
              this.getAllUrl(res.InterfaceAddress, loadingInstance)
            }
          })
    },
    getAllUrl (url, loadingInstance) {
      axios.post(url,
          {
            "token": {
              "sToken": "8BED23DE028E0E9966B8CE9E8F77DB89",
              "TimeSpan": "1535942069232"
            },
            "Version": "4",
            "Type":"VisumallIOSAPP"
          }
      )
          .then(res => {
            if (res && res.GetListResult.length > 0) {
              store.commit('bases/UpUrlArr', res.GetListResult)
              let item = new Map()
              for (let i = 0; i < res.GetListResult.length; i++) {
                item.set(res.GetListResult[i].IAKey, res.GetListResult[i].IAValue)
              }
              store.commit('bases/UpUrlMap', item)
              loadingInstance.close();
              this.priceSortList();
            }else {
              MessageBox('数据加载失败，请稍后再试！', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                center: true})
            }
          })
          .catch(err => {
            MessageBox('数据加载失败，请稍后再试！', '提示', {
              confirmButtonText: '确定',
              type: 'warning',
              center: true})
            loadingInstance.close();
          })
    },
    priceSortList() {
      let loadingInstance = Loading.service({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      });
      this._api.userCurdApi.PriceSortList(this.CHPProductId, this.ShopId)
          .then(res => {
            if (res && res.RecordCount > 0 && res.GetRelationListResult.length > 0) {
              loadingInstance.close();
              this.getRelationListResult = res.GetRelationListResult[0];
              this.ProductDetail = this.getRelationListResult.ProductDetail;
              this.Brand = this.ProductDetail.Brand;
              this.Product = this.ProductDetail.Product;
              this.AllProduct = this.ProductDetail.AllProduct;
              this.imgSrc = this.ProductDetail.ListUploadFile[0];
              this.SPPrice = this?.getRelationListResult?.ShopProduct ? this?.getRelationListResult?.ShopProduct?.SPShopPrice : '';
              this.carouselIndex = 0;
            }else {
              loadingInstance.close();
              MessageBox('数据加载失败，请稍后再试！', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                center: true})
            }
          });
    },
    register() {
      this.$router.push({path: '/Register'});
    },
    changeCarousel(e) {
      this.imgSrc = this.ProductDetail.ListUploadFile[e];
      this.carouselIndex = e;
    },
    setActiveItem(e) {
      let index = e.target.dataset.index;

      this.carouselIndex = index;
      this.$refs.carousel.setActiveItem(index);
    },
    addClick() {
      this.ProductNum++;
    },
    subClick() {
      if(this.ProductNum <= 1) {
        this.$alert('商品数量不可少于1', '提示');
      }
      else {
        this.ProductNum--;
      }
    },
    addCart() {
      let lo = this.$loading({
        text: '注册中...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      let CHPS_OP_ALL_Id = '00000000-0000-0000-0000-000000000000' ;
      this._api.userCurdApi.FrameDetailAddToCart(this.CHPChooseId, this.CHPProductId, this.Product.ProductSortKey, this.ProductNum,
          '', CHPS_OP_ALL_Id, '', this.Product.ProductOfficalPrice)
          .then(res => {
            lo.close()
            if (res.msg == 'Success') {
              this.$alert('加入购物车成功。', '提示');
            }else {
              this.$alert('加入购物车失败', '提示');
            }
          })
    },
    searchClick() {
      this.dialogTableVisible = true;
    }
  }
}
</script>

<style scoped lang="scss">
.PCProduct {
  min-width: 1024px;
  width: 60vw;
  margin: 0 auto;
  .product_top {
    align-items: flex-start;
    //margin-top: 0.35rem;
    .left {
      width: 30%;
      .big_Img {
        width: 100%;
        height: 100%;
      }
      .small_Img {
        width: 100%;
        flex-wrap: wrap;;
        overflow: hidden;
        overflow-x: auto;
        list-style: none;
        .img_border {
          margin-top: 0.05rem;
          width: 25%;
          img {
            width: 80%;
            border: 0.01rem solid #BCBCBC;
          }
          .pattern {
            border: 0.01rem solid red;
          }
        }
      }
      .el-carousel {
        border: 0.01rem solid #BCBCBC;
        .el-carousel__item:nth-child(2n) {
          //background-color: #99a9bf;
        }

        .el-carousel__item:nth-child(2n+1) {
          //background-color: #d3dce6;
        }
        ::v-deep .el-carousel__indicators {// 指示器
          display: none;
        }
        ::v-deep .el-carousel__arrow {
          background-color: rgba(31,45,61,0);
          color: #010101;
          font-size: 0.22rem;
        }
        ::v-deep .el-carousel__arrow--left {
          left: 0;
          opacity: 0.67;
        }
        ::v-deep .el-carousel__arrow--right {
          right: 0;
          opacity: 0.67;
        }
      }

      .left_search {
        width: 0.7rem;
        height: 0.7rem;
        left: 100%;
        top: 100%;
        z-index: 999;
        transform: translate(-120%, -120%);
        position: absolute;
        img {
          width: 50%;
        }
      }
    }
    .right {
      flex: 1;
      margin-left: 0.94rem;
      .product_name {
        //margin-top: 1.12rem;
        text-align: left;
        padding-left: 0.04rem;
        .title {
          font-size: 0.28rem;
        }
        .info {
          margin-top: 0.17rem;
          font-size: 0.25rem;
          color: #6F6F6F;
        }
      }
      .product_price {
        background: #e9e9e9;
        padding: 0.06rem 0.04rem;
        justify-content: flex-start;
        margin-top: 0.32rem;
        .price_tag {
          font-size: 0.21rem;
          color: #010101;
        }
        .price {
          margin-left: 0.17rem;
          font-size: 0.25rem;
          font-weight: bold;
          color: #FF0000;
        }
      }
      .product_num {
        padding-left: 0.04rem;
        margin-top: 0.46rem;
        justify-content: flex-start;
        .num_tag {
          font-size: 0.22rem;
          color: #010101;
        }
        .num {
          width: 0.65rem;
          height: 0.45rem;
          font-size: 0.17rem;
          line-height: 0.45rem;
          border: 0.01rem solid #7D7D7D;
          margin-left: 0.22rem;
        }
        .num_mode {
          margin-left: 0.05rem;
          div {
            cursor: pointer;
            border: 0.01rem solid #7D7D7D;
            width: 0.29rem;
            height: 0.2rem;
            font-size: 0.26rem;
            line-height: 0.2rem;
            color: #010101;
            text-align: center;
            //transform: rotate(90deg);
          }
          .num_add {
          }
          .num_sub {
            margin-top: 0.03rem;
          }
        }
      }
      .product_buy {
        margin-top: 1.8rem ;
        button {
          margin: 0 0.09rem;
          padding: 0.22rem 0.58rem;
          border-radius: 0.1rem;
          border: 0.01rem solid #FF0000;
          font-size: 0.23rem;
        }
        .buy {
          color: #FF0000;
          background: #FFEDED;
        }
        .shop {
          position: relative;
          img {
            width: 0.34rem;
            height: 0.34rem;
            position: absolute;
            left: 15%;
            top: 50%;
            transform: translate(-50%, -50%);
          }
          background: #FF0000;
          color: #FFFFFF;
        }
      }
    }
  }
  .product_details {
    margin-top: 0.56rem;
    text-align: left;
    .details_top {
      padding: 0.18rem 0.34rem;
      background: #e9e9e9;
      margin-bottom: 0.12rem;
      font-size: 0.25rem;
      color: #006CFF;
    }
    .details_body {
      background: #e9e9e9;
      padding: 0.13rem 0.34rem 0;
      .details_item {
        margin-bottom: 0.3rem;;
        justify-content: flex-start;
        font-size: 0.25rem;
        .tag {
          font-weight: bold;
        }
        .details {
          margin-left: 0.1rem;
          color: #6F6F6F;
        }
      }
      .details_items {
        justify-content: flex-start;
        flex-wrap: wrap;
        .details_item {
          width: 40%;
        }
        .details_item1 {
          width: 60%;
        }
      }
    }
  }
  .details_intro {
    .intro_border {
      margin-top: 	0.15rem;
      img {
        width:100%;
      }
    }
  }
  .dialog {
    ::v-deep .el-dialog {
      width: 70%;
    }
  }
}
</style>
